module.exports = __webpack_public_path__ + "img/man-presenting.9066fb21.png";